import _clonedeep from 'lodash.clonedeep'
import _get from 'lodash.get'
import _set from 'lodash.set'

export default {
  props: {
    /**
     * @description 表格数据
     */
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      /**
       * @description 表格内部数据
       */
      apexTableData: [],
      filterColumnObj: {}
    }
  },
  computed: {
    apexTableDataLength() {
      return this.apexTableData.length
    }
  },
  watch: {
    data: {
      handler() {
        this.handleDataChange()
        if (this.apexTablePagination && this.clientPagination) {
          this.initClientPagination()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.handleDataChange()
    this.initFilterColumnObj()
  },
  methods: {
    /**
     * @description lodash.get
     */
    _get,
    /**
     * @description lodash.set
     */
    _set,
    /**
     * @description 同步外部表格数据到apexTableData内部
     */
    handleDataChange() {
      if (this.apexTableData !== this.data) {
        this.apexTableData = _clonedeep(this.data)
        this.syncData()
      }
    },
    // 初始化过滤列数据
    initFilterColumnObj() {
      this.columns.forEach(item => {
        if (item.filterColumn) {
          if (item.filterColumn.keys && item.filterColumn.keys.length > 0) {
            item.filterColumn.keys.forEach((columnKey, index) => {
              if (item.filterColumn.name === 'begin-end-date') {
                if (item.filterColumn.value && item.filterColumn.value.length > 0) {
                  this.$set(this.filterColumnObj, columnKey, this.handleData(item.filterColumn.value[index]) || '')
                }
              } else {
                this.$set(this.filterColumnObj, columnKey, this.handleData(item.filterColumn.value) || '')
              }
            })
            return
          }
          if (item.filterColumn.name) {
            this.$set(this.filterColumnObj, item.key, this.handleData(item.filterColumn.value) || '')
          }
        }
      })
    },
    // 同步数据
    syncData() {
      this.$nextTick(() => {
        this.syncRadioStatus()
      })
    },
    // 同步单选状态
    syncRadioStatus() {
      this.checkedRow = this.$refs.elTable.store.states.currentRow
      this.$emit('current-change', this.checkedRow)
    },
    /**
     * @description 排序状态
     */
    handleSortChange({ column, prop, order }) {
      this.$emit('sort-change', { column, prop, order })
      this.$emit('table-data-change', this.$refs.elTable.tableData)
    },
    /**
     * @description 更新行数据
     * @param {Number} index 表格数据索引
     * @param {Object} row 更新的表格行数据
     */
    handleUpdateRow(index, row) {
      this.$set(this.apexTableData, index, row)
    },
    /**
     * @description 删除行
     * @param {Object} index 被删除行索引
     */
    handleRemoveRow(index) {
      this.$delete(this.apexTableData, index)
    },
    filterColumnChange(obj, value) {
      if (obj.filterColumn.isRemote) {
        this.remoteColumn(obj.key, value)
      } else {
        this.filterColumn(obj.filterColumn.customMethod, obj.key, value, obj.filterColumn.isRemote, obj.filterColumn.type)
      }
    },
    // 搜索过滤列
    filterColumn(customMethod, key, value, isRemote, type) {
      if (isRemote) {
        return
      }
      if (customMethod) {
        customMethod(key, value)
        return
      }
      if (value || value === 0 || value === false) {
        let keyWords = value.toString().split(' ').filter(item => item)
        if (Array.isArray(value)) {
          if (value.length > 0) {
            keyWords = value.filter(item => item)
          } else {
            this.apexTableData = this.data
            return
          }
        }
        this.apexTableData = this.data.filter(item => {
          if (typeof item[key] === 'string') {
            if (type === 'daterange') {
              const itemDate = new Date(Date.parse(item[key]))
              return itemDate >= new Date(Date.parse(keyWords[0])) && itemDate <= new Date(Date.parse(keyWords[1]))
            } else {
              return item[key] && keyWords.find(keyWord => item[key].toLowerCase().includes(keyWord.toString().toLowerCase()))
            }
          } else {
            let strValue = item[key] && _clonedeep(item[key]).toString()
            if (typeof item[key] === 'number' || typeof item[key] === 'boolean') {
              strValue = item[key].toString()
            }
            return strValue && keyWords.find(keyWord => strValue.includes(keyWord))
          }
        })
      } else {
        this.apexTableData = this.data
      }
      this.$emit('filter-column-change', { key: key, value })
    },
    // 列回车远程搜索
    remoteColumn(key, value) {
      this.$emit('filter-column-remote', { key: key, value })
    },
    // 控制beginDate和endDate的选择范围
    beginDateFn(time, endDate) {
      return time.getTime() > Date.parse(endDate)
    },
    endDateFn(time, beginDate) {
      const previousDay = new Date(Date.parse(beginDate) - 24 * 60 * 60 * 1000) // 获取beginDate的前一天
      return time.getTime() < previousDay.getTime()
    }
  }
}
